import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

import { UrlManager } from "@/shared/apis/UrlManager";

import { StyledDisplayBrokerContainer } from "../../styled";
import { StyledBrokerAddressContainer, StyledBrokerImage, StyledBrokerName } from "./styled";

type RegisterChooseBrokerDisplayProps = {
    broker: MyBrokerApi.Broker;
    onWrongBroker: () => void;
    onConfirmBroker: () => void;
};

const RegisterChooseBrokerDisplay: FC<RegisterChooseBrokerDisplayProps> = ({
    broker,
    onWrongBroker,
    onConfirmBroker,
}) => {
    const { t } = useTranslation();

    const renderBrokerImage = () => {
        return (
            <StyledBrokerImage>
                <img src={UrlManager.brokerLogo(broker.officeId)} alt="" />
            </StyledBrokerImage>
        );
    };

    return (
        <>
            <StyledDisplayBrokerContainer data-testid="RegisterChooseBrokerDisplay">
                {renderBrokerImage()}
                <StyledBrokerName>{broker.brokerName}</StyledBrokerName>
                <StyledBrokerAddressContainer>
                    <p className="broker-address">{broker.address}</p>
                    <p className="broker-sub-address">
                        {broker.zipCode} {broker.city}
                    </p>
                </StyledBrokerAddressContainer>
                <div className="form-bottom-container">
                    <Button
                        data-testid="register_choose_broker_display-button-wrongBroker"
                        variant="outlined"
                        fullWidth
                        onClick={onWrongBroker}
                    >
                        {t("Registration.ChooseBroker.WrongBroker")}
                    </Button>
                    <br />
                    <br />
                    <Button data-testid="button_confirm" fullWidth onClick={onConfirmBroker}>
                        {t("Common.Confirm")}
                    </Button>
                </div>
            </StyledDisplayBrokerContainer>
        </>
    );
};

export default RegisterChooseBrokerDisplay;
